var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRuble = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.896 5.59v6.486h2.626q1.724 0 2.615-.857.89-.867.89-2.397 0-1.52-.89-2.375-.88-.857-2.615-.857zm3.14 8.267h-3.14v2.192h4.739v1.37H9.896V20H7.841v-2.58H5.557v-1.37h2.284v-2.193H5.557v-1.37h2.284V3.763h5.218q2.283 0 3.677 1.428 1.404 1.426 1.404 3.63t-1.404 3.62q-1.405 1.416-3.7 1.416"
})));
export default SvgRuble;